export const Faq = {

  list: function() {
    jQuery('[data-tooltip="true"]').tooltip();

    // faq sorting
    $('.faq-row-container').sortable({
      items: '.faq-row',
      handle: '.faq-reorder-icon',
      axis: 'y',
      start: function (e, ui) { $(ui.item).addClass('phase-dragging') },
      stop: function (e, ui) { $(ui.item).removeClass('phase-dragging') },
      update: function () {
        ActionJS.Faq.priv.saveFaqOrder(this);
      }
    });
  },


  new: function() {
    TinyMCEHelper.init({
      selector: '#faq_content',
      plugins: 'link table',
      menubar: false,
      toolbar: 'styleselect | bold italic link | undo redo | table',
      statusbar: false,
      link_list: JSON.parse(jQuery('#faq-documents-json').html()),
      relative_urls: false
    });

    jQuery('.smartme-toggle').smartmeToggle();

    jQuery('form #faq_title').on('input', function(e) {
      jQuery(this).val(jQuery(this).val().replace(/\n/g, ''));
    });
  },


  create: function () {
    ActionJS.Faq.new();
  },


  edit: function() {
    ActionJS.Faq.new();
  },


  update: function () {
    ActionJS.Faq.new();
  },


  priv: {
    saveFaqOrder: function (target) {
      jQuery.ajax({
        url: jQuery(target).data('url'),
        method: 'post',
        data: { sort_order: jQuery(target).find('[name="faq[][id]"]').map(function (k, v) { return jQuery(this).val() }).get() }
      }).error(function (resp) {
        alert('error saving sort order');
      });
    },
  }

};